// Hook odpowiedzialny za pobranie listy dostaw

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest
} from 'api/types';

export interface IDeliveryListItem {
  id: number;
  order_id: number;
  symbol: string;
  order_currency: string;
  order_value_net: number;
  order_value_net_formatted: string;
  order_value_gross: number;
  order_value_gross_formatted: string;
  receiver_address: {
    street: string;
    postal_code: string;
    city: string;
  };
  delivery_date: string | null;
  delivery_date_formatted?: string | null;
  delivery_date_to_show_formatted?: string | null;
  shipping_date?: string | null;
  shipping_date_formatted?: string | null;
  products_count: number;
  order_products_count?: number;
  package_numbers?: number;
  place_name?: string;
  status_delivery?: string;
  status?: {
    color?: string | null;
    label?: string | null;
    icon?: string | null;
  };
  tracking_number?: string;
  tracking_url?: string;
  delivery_method_name?: string;
  delivery_method_icon_image_url?: string;
}

// parametry requestu do api
export type IRequest = IPaginationRequest &
  ISearchRequest & {
    date_from?: string;
    date_to?: string;
    order_id?: number;
  };

// typ zwracanych danych
type IResponse = IPaginationResponse<IDeliveryListItem>;

const getDeliveries = (params?: IRequest): Promise<IResponse> =>
  axios.get('/deliveries', { params });

export const useGetDeliveries = (params?: IRequest, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['deliveries', params], () => getDeliveries(params), options);
